
<template>
  <div>
    <section class="banners">
      <div class="swiper-banner swiper-container swiper-no-swiping">
        <div class="carousel-body swiper-wrapper">
          <div
            v-for="(item, index) in bannerArr"
            :key="index"
            class="swiper-slide carousel-box"
          >
            <img :src="item.imgurl" draggable="false" />
          </div>
        </div>
      </div>
    </section>
    <div class="fixed-div">
      <div class="main-div" @mouseover="showSt = true">
        <img
          src="../assets/img/flow/fixed/float.png"
          alt=""
          @mouseout="showSt = false"
        />
      </div>
      <div
        class="content-wrap"
        :class="showSt ? 'showSt' : ''"
        @mouseover="showSt = true"
        @mouseout="showSt = false"
      >
        <div class="par-wrap" @click="toContact">
          <img src="../assets/img/flow/fixed/phone_icon.png" alt="" />
          <div class="par-desc">
            <h4>广告商务合作</h4>
            <p>联系邮件：</p>
            <p>ad@chinanola.com</p>
            <p>或留下信息我们联系您</p>
          </div>

        </div>
        <div class="weixin-wrap">
            <img src="../assets/img/flow/fixed/weixin.png" class="weixin" alt="">
            <div class="img-wrap">
              <img src="../assets/img/channel-wchat.jpg" alt="">
            </div>
        </div>
      </div>
    </div>
    <div class="container">
      <!-- 大数据智能算法 -->
      <section class="push">
        <h4>大数据智能算法</h4>
        <p>千人千面·精准抵达</p>
        <div class="channels">
          <div class="card">
            <img src="../assets/img/icon_1.png" alt="今日头条" />
            <div class="push-desc">
              <h6>今日头条</h6>
              <p>
                个性化资讯推荐引擎产品，致力于连接人与信息，让优质、丰富的信息得到高效、精准的分发，促使信息创造价值。
              </p>
            </div>
          </div>
          <div class="card">
            <div class="push-desc">
              <h6>抖音短视频</h6>
              <p>
                国民级视频社交平台，月度活跃用户规模超过8.5亿，高效触达用户，沉浸式渗透闭环转化。
              </p>
            </div>
            <img src="../assets/img/icon_2.png" alt="抖音短视频" />
          </div>
          <div class="card">
            <img src="../assets/img/icon_3.png" alt="西瓜视频" />
            <div class="push-desc">
              <h6>西瓜视频</h6>
              <p>
                基于人工智能算法为用户做短视频内容推荐，让用户每一次刷新产生价值。
              </p>
            </div>
          </div>
          <div class="card">
            <div class="push-desc">
              <h6>火山小视频</h6>
              <p>
                通过小视频帮助用户迅速获取内容，展示自我，获得粉丝，发现同好。
              </p>
            </div>
            <img src="../assets/img/icon_4.png" alt="火山小视频" />
          </div>
          <div class="card">
            <img src="../assets/img/icon_5.png" alt="穿山甲" />
            <div class="push-desc">
              <h6>穿山甲</h6>
              <p>垂直深耕，深度互动，短时间一站式覆盖，为广告主首选。</p>
            </div>
          </div>
        </div>
      </section>
      <!-- 让信息“主动招人” -->
      <section class="h3-wrap">
        <h4>让信息“主动招人”</h4>
        <p>基于大数据智能算法推荐，通过多种定向方式</p>
        <p>(人群定向、兴趣定向、内容定向)，将广告精准分发给目标人群</p>
        <div class="h3-content">
          <div class="wrap">
            <div
              class="item-wrap"
              :class="bigShow == 3 ? 'bigShow' : ''"
              @mouseover="bigShow == 3 ? '' : (bigShow = 3)"
            >
              <div class="item">
                <div class="title-wrap douyin-zb">
                  <div class="bgDiv">
                    <div>
                      <div class="title">抖音直播</div>
                      <svg
                        t="1626762595476"
                        v-if="bigShow != 3"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="1993"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M717.312 477.866667l-214.801067-214.801067 48.298667-48.264533L848.008533 512l-297.198933 297.198933-48.298667-48.264533L717.312 546.133333H170.666667v-68.266666z"
                          p-id="1994"
                          fill="#ffffff"
                        ></path>
                      </svg>
                      <div class="line" v-show="bigShow == 3"></div>
                      <p class="summary" v-show="bigShow == 3">
                        抖音美好高品质直播，持续助力营销加速
                      </p>
                    </div>
                  </div>
                </div>
                <div class="right-wrap">
                  <div class="right-wrap-2">
                    <div class="content-wrap">
                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p style="color: #999; font-size: 14px">
                            2020年直播迎来大爆发，月度用户规模超过5.6亿，从「秀场直播」到「直播+」，直播不断突破商业边际，开屏超级视觉冲击，品牌信息完整触达
                          </p>
                        </div>
                        <!-- <div class="desc">
                          2020年直播迎来大爆发，月度用户规模超过5.6亿,从「秀场直播」到「直播+」，直播不断突破商业边际,开屏超级视觉冲击，品牌信息完整触达
                        </div> -->
                      </div>
                      <div class="line"></div>
                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>FeedsLive</p>
                        </div>
                        <div class="desc">
                          直播高效引流，多样化营销导向，满足品牌直播诉求
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>巨量千川</p>
                        </div>
                        <div class="desc">
                          创新创意形式，升级转化归因，盘活私域流量
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>游戏直播间引流</p>
                        </div>
                        <div class="desc">
                          抖音小风车直挂，助力游戏广告主转化
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="item-wrap"
              :class="bigShow == 2 ? 'bigShow' : ''"
              @mouseover="bigShow == 2 ? '' : (bigShow = 2)"
            >
              <div class="item">
                <div class="title-wrap toutiao-app">
                  <div class="bgDiv">
                    <div>
                      <div class="title">今日头条APP</div>
                      <svg
                        t="1626762595476"
                        class="icon"
                        v-if="bigShow != 2"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="1993"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M717.312 477.866667l-214.801067-214.801067 48.298667-48.264533L848.008533 512l-297.198933 297.198933-48.298667-48.264533L717.312 546.133333H170.666667v-68.266666z"
                          p-id="1994"
                          fill="#ffffff"
                        ></path>
                      </svg>
                      <div class="line" v-show="bigShow == 2"></div>
                      <p class="summary" v-show="bigShow == 2">
                        个性化资讯推荐引擎产品，致力于连接人与信息，让优质、丰富的信息得到高效、精准的分发，促使信息创造价值。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="right-wrap">
                  <div class="right-wrap-2">
                    <div class="content-wrap">
                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>开屏广告</p>
                        </div>
                        <div class="desc">
                          App启动时展示，第一时间锁定用户注意力；
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>信息流广告</p>
                        </div>
                        <div class="desc">资讯流中穿插展现的原生广告形式；</div>
                      </div>
                      <div class="line"></div>

                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>详情页广告</p>
                        </div>
                        <div class="desc">
                          文章/问答/视频详情页中图片、视频等多样式广告样式；
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="item-wrap"
              :class="bigShow == 1 ? 'bigShow' : ''"
              @mouseover="bigShow == 1 ? '' : (bigShow = 1)"
            >
              <div class="item">
                <div class="title-wrap douyin-app">
                  <div class="bgDiv">
                    <div>
                      <div class="title">抖音APP</div>
                      <svg
                        t="1626762595476"
                        v-if="bigShow != 1"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="1993"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M717.312 477.866667l-214.801067-214.801067 48.298667-48.264533L848.008533 512l-297.198933 297.198933-48.298667-48.264533L717.312 546.133333H170.666667v-68.266666z"
                          p-id="1994"
                          fill="#ffffff"
                        ></path>
                      </svg>
                      <div class="line" v-show="bigShow == 1"></div>
                      <p class="summary" v-show="bigShow == 1">
                        国民级视频社交平台，月度活跃用户规模超过8.5亿，高效触达用户，沉浸式渗透闭环转化。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="right-wrap">
                  <div class="right-wrap-2">
                    <div class="content-wrap">
                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>开屏广告</p>
                        </div>
                        <div class="desc">App启动时展示，强视觉冲击；</div>
                      </div>
                      <div class="line"></div>

                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>信息流广告</p>
                        </div>
                        <div class="desc">
                          满足曝光、点击、应用下载、粉丝增长等多维度营销需求；
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>挑战赛话题</p>
                        </div>
                        <div class="desc">
                          触发用户互动为核心的话题营销模式，多维模式满足企业话题热度需求；
                        </div>
                      </div>
                      <div class="line"></div>

                      <div class="item-content">
                        <div class="con-hd">
                          <img src="../assets/img/flow/zuan_icon.jpg" />
                          <p>企业蓝V认证</p>
                        </div>
                        <div class="desc">
                          针对企业“内容+营销”的诉求，依托平台特性，企业认证蓝V可持续创作经营；
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="h4-wrap">
        <div class="wrap" id="d-top">
          <div class="swiper-container news-swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in cloms"
                :key="index"
              >
                <div class="box-wrap">
                  <div class="img-wrap">
                    <img :src="item.icon" alt="" />
                  </div>
                  <div class="content-wrap">
                    <div class="title">
                      <h4>{{ item.title }}</h4>
                    </div>
                    <div v-show="showDetail == index" class="desc">
                      <p>{{ item.content }}</p>
                    </div>
                    <div class="content">
                      <p>合作内容：{{ item.cooperation }}</p>
                      <p>
                        传播效果：{{ item.spread }}
                        <span class="red_Num">{{ item.num }}</span>
                      </p>
                    </div>
                    <div class="btn-wrap" v-show="showDetail != index">
                      <button @click="showDetail = index">查看详情</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="part-wrap">
        <h4>我们的合作伙伴</h4>
        <p>强强联手，共创品效协同</p>
        <div class="wrap">
          <div class="item-wrap" v-for="(item, index) in partners" :key="index">
            <img :src="item.icon" alt="" srcset="" v-if="index < 16" />
            <img
              :src="item.icon"
              alt=""
              srcset=""
              v-if="moreShow && index >= 16"
            />
          </div>
          <div class="more" v-show="!moreShow" @click="moreShow = true">
            <span>查看更多</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "channel",
  data() {
    return {
      partners: [
        {
          icon: require("../assets/img/flow/par/partner_1.png"),
          nickname: "世遗大会",
          type: 1,
        },
        {
          icon: require("../assets/img/flow/par/partner_2.png"),
          nickname: "外交部福建全球推介",
          type: 1,
        },
        {
          icon: require("../assets/img/flow/par/partner_3.png"),
          nickname: "绿色食品发展中心",
          type: 1,
        },
        {
          icon: require("../assets/img/flow/par/partner_4.png"),
          nickname: "最美人物",
          type: 1,
        },
        {
          icon: require("../assets/img/flow/par/partner_5.png"),
          nickname: "东南卫视",
          type: 1,
        },
        {
          icon: require("../assets/img/flow/par/partner_6.png"),
          nickname: "厦门邮轮",
          type: 1,
        },
        {
          icon: require("../assets/img/flow/par/partner_7.png"),
          nickname: "春秋国旅",
          type: 1,
        },
        {
          icon: require("../assets/img/flow/par/partner_8.png"),
          nickname: "碧桂园",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_9.png"),
          nickname: "保利地产",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_10.png"),
          nickname: "泰禾集团",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_11.png"),
          nickname: "融侨集团",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_12.png"),
          nickname: "万达集团",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_13.png"),
          nickname: "联发集团",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_14.png"),
          nickname: "世纪金源集团",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_15.png"),
          nickname: "宝龙城市广场",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_16.png"),
          nickname: "三棵树",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_17.png"),
          nickname: "信用家",
          type: 2,
        },
        {
          icon: require("../assets/img/flow/par/partner_18.png"),
          nickname: "中国移动",
          type: 3,
        },
        {
          icon: require("../assets/img/flow/par/partner_19.png"),
          nickname: "中国联通",
          type: 3,
        },
        {
          icon: require("../assets/img/flow/par/partner_20.png"),
          nickname: "中国电信",
          type: 3,
        },
        {
          icon: require("../assets/img/flow/par/partner_21.png"),
          nickname: "星空互娱",
          type: 4,
        },
        {
          icon: require("../assets/img/flow/par/partner_22.png"),
          nickname: "工商银行",
          type: 5,
        },
        {
          icon: require("../assets/img/flow/par/partner_23.png"),
          nickname: "兴业银行",
          type: 5,
        },
        {
          icon: require("../assets/img/flow/par/partner_24.png"),
          nickname: "光大银行",
          type: 5,
        },
        {
          icon: require("../assets/img/flow/par/partner_25.png"),
          nickname: "中国平安",
          type: 5,
        },
        {
          icon: require("../assets/img/flow/par/partner_26.png"),
          nickname: "人保财险",
          type: 5,
        },
        {
          icon: require("../assets/img/flow/par/partner_27.png"),
          nickname: "瑞达期货",
          type: 5,
        },
        {
          icon: require("../assets/img/flow/par/partner_28.png"),
          nickname: "雅美佳口腔",
          type: 6,
        },
        {
          icon: require("../assets/img/flow/par/partner_29.png"),
          nickname: "六福珠宝",
          type: 7,
        },
        {
          icon: require("../assets/img/flow/par/partner_30.png"),
          nickname: "盘子女人坊",
          type: 7,
        },
        {
          icon: require("../assets/img/flow/par/partner_31.png"),
          nickname: "百威啤酒",
          type: 7,
        },
        {
          icon: require("../assets/img/flow/par/partner_32.png"),
          nickname: "宝岛眼镜",
          type: 7,
        },
        {
          icon: require("../assets/img/flow/par/partner_33.png"),
          nickname: "永辉彩食鲜",
          type: 7,
        },
        {
          icon: require("../assets/img/flow/par/partner_34.png"),
          nickname: "回头客",
          type: 7,
        },
        {
          icon: require("../assets/img/flow/par/partner_35.png"),
          nickname: "海南春光",
          type: 7,
        },
      ],
      cloms: [
        {
          icon: require("../assets/img/flow/icon_case_1.png"),
          title: "抖IN福州·遇见世遗",
          content:
            "抖IN CITY启动以来，以“人”为纽带，加速城市和年轻人的心里破壁，持续解锁城市新域",
          cooperation: "抖音挑战赛/话题/开屏",
          spread: "挑战赛话题阅读量",
          num: "1亿",
        },
        {
          icon: require("../assets/img/flow/icon_case_2.png"),
          title: "三棵树“健康漆”",
          content: "三棵树漆健康+ 8小时净味住新家",
          cooperation: "抖音开屏/信息流广告",
          spread: "总曝光",
          num: "4亿+",
        },
        {
          icon: require("../assets/img/flow/icon_case_3.png"),
          title: "信用家一站式智慧装修服务平台",
          content: "拒绝装修猫腻，10分钟搞定装修报价",
          cooperation: "信息流广告",
          spread: "总曝光",
          num: "7亿+",
        },
        {
          icon: require("../assets/img/flow/icon_case_4.png"),
          title: "知名品牌七匹狼/匹克/天福茗茶/海南春光等",
          content:
            "助力抖音商家直播，为抖音直播生态严格把控。做好品牌在抖音的入驻，做到品牌和火吖的共同成长",
          cooperation: "直播/快速打造从0到1直播间",
          spread: "GMV千川直播",
          num: " 1000万+",
        },
      ],
      pages: "2",
      bannerArr: [
        {
          imgurl: require("../assets/img/flow/channel_banner1.jpg"),
          title: "信息流广告",
        },
        {
          imgurl: require("../assets/img/flow/channel_banner2.png"),
          title: "信息流广告",
        },
        {
          imgurl: require("../assets/img/flow/channel_banner3.jpg"),
          title: "信息流广告",
        },
      ],
      showDetail: null,
      showTop: false,
      bigShow: 3,
      isOver: 1,
      activeIndex: 1,
      showSt: false,
      currIndex: 0,
      moreShow: false,
    };
  },
  created() {
    // this.$ajax
    //   .post("/banners/" + this.pages)
    //   .then(function (res) {
    //     vm.bannerUrl = res.data.banners[0].imgurl;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var swiper = new Swiper(".news-swiper", {
        pagination: ".swiper-pagination",
        autoplay: 5000,
        autoplayDisableOnInteraction: false,
        // spaceBetween: 42,
      });
      var swiper = new Swiper(".swiper-banner", {
        autoplay: 5000,
        autoplayDisableOnInteraction: false,
        // spaceBetween: 42,
      });
    },
    toContact() {
      this.$router.push("/contact");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/fixed";
@import "../assets/css/base/_fonts";


// 大数据智能算法
.push {
  padding-top: 1rem;
  > h4,
  > p {
    text-align: center;
  }
  > h4 {
    margin-bottom: 0.5rem;
  }
  .channels {
    .card {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      // &:hover {
      //   box-shadow: 0 3px 5px 3px rgba(0, 0, 0, 0.06);
      //   transform: translateY(-10px);
      // }
      img {
        width: 100%;
        max-width: 130px;
        max-height: 130px;
        margin: 0 auto 20px;
      }
      .push-desc:nth-child(odd) {
        margin-right: 10%;
      }
      .push-desc:nth-child(even) {
        margin-left: 10%;
      }
      h6 {
        font-size: 1.2rem;
        font-weight: 700;
        margin-bottom: 10px;
        color: #535353;
      }
      p {
        text-align: left;
        color: #535353;
      }
    }
  }
}
// 让信息“主动招人”
.douyin-app {
  background: url("../assets/img/flow/icon_Blue_3.png") !important;
  background-size: 100% 100% !important;
}
.douyin-zb {
  background: url("../assets/img/flow/icon_Blue_1.png") !important;
  background-size: 100% !important;
  border-radius: 20px 20px 0 0;
}
.toutiao-app {
  background: url("../assets/img/flow/icon_Blue_2.png") !important;
  background-size: 100% 100% !important;
}
.h3-wrap {
  margin-top: 50px;
  > h4,
  > p {
    text-align: center;
  }
  > h4 {
    margin-bottom: 0.5rem;
  }
  > p {
    line-height: 1rem;
  }
  .h3-content {
    margin-top: 2rem;
  }
  .bigShow {
    .title-wrap {
      opacity: 1;
      visibility: visible;
    }
    .content-wrap {
      height: 500px !important;
    }
    .right-wrap {
      &::after {
        border: 12px solid transparent;
        border-right-color: #fff;
        content: "";
        left: 160px;
        position: absolute;
        top: -22px;
        transform: rotate(90deg);
      }
    }

    .line {
      background: #fff;
      border-radius: 1.76px;
      border-radius: 1.75609756px;
      height: 2px;
      margin: 20px auto;
      text-align: center;
      width: 42px;
    }
    .summary {
      color: #fff;
      font-size: 12px !important;
      line-height: 17px;
      margin: 0 auto;
      text-align: center;
      width: 144px;
    }
    .bgDiv {
      background-image: linear-gradient(
        -46deg,
        rgba(74, 141, 247, 0.85),
        #704efc
      ) !important;
      > div {
        animation: shad 0.5s ease-in-out;
      }
    }
    @keyframes shad {
      0% {
        transform: translate(40px, 0);
      }
      100% {
        transform: translate(0px, 0);
      }
    }
  }
  .item {
    position: relative;
    .title-wrap {
      align-items: center;
      background: rgba(21, 20, 73, 0.85);
      color: #fff;
      display: flex;
      flex-grow: 0;
      font-size: 26px;
      height: 190px;
      margin: 0 auto;
      text-align: center;
      vertical-align: middle;
      // width: 210px;

      .bgDiv {
        display: flex;
        align-items: center;
        background-image: linear-gradient(
          -46deg,
          rgba(14, 13, 65, 0.85),
          #1e1c65
        );
        height: 0;
        justify-content: center;
        margin: 0 auto;
        width: 100%;
        > div {
          padding: 10px;
        }
      }
      .title {
        color: #fff;
        margin: 0 auto 24px;
      }
      svg {
        display: block;
        margin: 10px auto;
      }
    }
    .right-wrap {
      background: #fff;
      position: relative;

      .right-wrap-2 {
        height: 100%;
        overflow: hidden;
        position: relative;
        transition: all 0.5s ease-in-out;
      }
    }
    .content-wrap {
      display: flex;
      height: 0;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 30px;
      .line {
        padding: 0;
        margin: 0;
        width: 100%;
        height: 1px;
        background-color: #e6e6e6;
      }
      .item-content {
        margin: auto 0;
        &:last-of-type {
          border: 0;
        }
        .con-hd {
          display: flex;
          padding: 10px 0;

          p {
            font-size: px2rem(18);
            color: #333;
            line-height: 26px;
            padding-left: 2%;
          }
          > img {
            height: 26px;
            width: 26px;
          }
        }
      }
      .desc {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #999;
        display: inline-block;
        display: -webkit-box !important;
        font-size: 0.8rem;
        padding-left: 34px;
        height: 34px;
        line-height: 17px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.h4-wrap {
  padding: 5rem 0 0 0;
  h4 {
    font-size: 1.2rem;
  }
  .wrap {
    .news-swiper {
      height: 450px;
    }
  }
  .box-wrap {
    width: 320px;
    border-radius: 20px;
    margin: 0 auto;
    box-shadow: 0 0 5px #999;
    padding-bottom: 2rem;
    .img-wrap {
      img {
        border-radius: 1rem 1rem 0 0;
      }
    }
    .content-wrap {
      .title {
        padding: 0.5rem 1rem 0.5rem 1rem;
        border-bottom: 1px solid rgb(245, 245, 245);
        h4 {
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .desc {
        padding: 0.5rem 1rem;
        margin-top: 1rem;
        p {
          text-align: center;
        }
      }
      .content {
        padding: 1rem;
        p {
          text-align: center;
          font-size: 0.8rem;
          line-height: 1.4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /*规定最多显示两行*/
        }
        .red_Num {
          color: rgb(178, 16, 16);
          font-size: 1.4rem;
        }
      }
      .btn-wrap {
        display: flex;
        justify-content: center;
        button {
          width: 80%;
          height: 3rem;
          border-radius: 2rem;
          background-color: #fff;
          border: 1px solid rgb(178, 16, 16);
          color: rgb(178, 16, 16);
        }
      }
    }
  }
}

// 合作伙伴
.part-wrap {
  > h4 {
    margin-bottom: 0.5rem;
  }
  h4,
  p {
    text-align: center;
  }
  p {
    margin-bottom: 1rem;
  }
  .wrap {
    .item-wrap {
      width: 25%;
      display: inline-block;
    }
  }
  .more {
    position: relative;
    bottom: 6rem;
    padding: 1rem 0;
    text-align: center;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/channels.vue